import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../shared/MDTypography";
import { IResultDTO, MovimentacaoTurmaViewModel, IDetalheTurma } from '../DetalheType';
import MDButton from "../../shared/MDButton";

interface IProps {  
  listaTurma: IResultDTO | null;
  qtdAlunos: number; 
  byId: boolean; 
  selecaoAluno: any;
}

/** Remove duplicatas por clienteId (mesmo aluno em vários horários aparece só uma vez) */
function deduplicaPorCliente(alunos: IDetalheTurma[]): IDetalheTurma[] {
  const vistos = new Set<string>();
  return alunos.filter((item) => {
    if (vistos.has(item.clienteId)) return false;
    vistos.add(item.clienteId);
    return true;
  });
}

/** Agrupa alunos por turma (turmaId + nomeTurma) para a lista de todas as turmas */
function groupAlunosByTurma(data: IDetalheTurma[] | undefined): { turmaId: string; nomeTurma: string; alunos: IDetalheTurma[] }[] {
  if (!data?.length) return [];
  const map = new Map<string, { nomeTurma: string; alunos: IDetalheTurma[] }>();
  for (const item of data) {
    const key = item.turmaId;
    if (!map.has(key)) {
      map.set(key, { nomeTurma: item.nomeTurma, alunos: [] });
    }
    map.get(key).alunos.push(item);
  }
  return Array.from(map.entries()).map(([turmaId, { nomeTurma, alunos }]) => ({
    turmaId,
    nomeTurma,
    alunos: deduplicaPorCliente(alunos),
  }));
}

export default function BoxDetalheTurma({listaTurma, qtdAlunos, byId, selecaoAluno} : IProps){  
  const [listAlunosSelecionados, setListAlunosSelecionados] = useState<MovimentacaoTurmaViewModel>(null);

  const turmasComAlunos = useMemo(
    () => groupAlunosByTurma(listaTurma?.data),
    [listaTurma?.data]
  );

  useEffect(() => {
    if (listAlunosSelecionados !== null){
      selecaoAluno(listAlunosSelecionados)}    
  }, [listAlunosSelecionados])
  

  const handleSelecionaAluno = (idAluno) => {    
      const updatedList = listAlunosSelecionados?.AlunosMovimentacao || []; 
      if (updatedList.includes(idAluno)) {      
        setListAlunosSelecionados(prevState => ({
          ...prevState,
          AlunosMovimentacao: updatedList.filter(item => item !== idAluno)
        }));        
      } else {      
        setListAlunosSelecionados(prevState => ({
          ...prevState,
          AlunosMovimentacao: [...updatedList, idAluno]
        }));
      }
    
  }

  const listaAlunosUnicos = useMemo(
    () => deduplicaPorCliente(listaTurma?.data ?? []),
    [listaTurma?.data]
  );

  return (
    <>
      {byId ? (
        <Grid container p={4} xl={12}>
          <Grid item xl={12}>
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >          
              <MDTypography variant="h6" color="white" flexDirection={"column"} style={{marginLeft: 8}} p={1}>
                {listaTurma?.data?.[0]?.nomeTurma ?? 'Turma'} - VAGAS: {qtdAlunos - listaAlunosUnicos.length}
              </MDTypography>                                   
            </MDBox>  
            {listaAlunosUnicos.map((item)=>(
              <Grid item xl={12} key={item.clienteId}>                
                <MDButton style={{marginTop: 8, backgroundColor: !listAlunosSelecionados?.AlunosMovimentacao.includes(item.clienteId) ? '#fff' : 'green', width: '100%'}}
                  onClick={() => handleSelecionaAluno(item.clienteId)}
                >
                    <MDTypography style={{marginLeft: 20, textAlign: 'start'}}>
                        {item.nomeCliente}
                    </MDTypography>
                </MDButton>                                           
            </Grid>
            ))}
            
          </Grid>            
        </Grid>
      ):(
        <Grid container p={4} lg={12} spacing={3}>
          {turmasComAlunos.map(({ turmaId, nomeTurma, alunos }) => (
            <Grid item xs={12} md={6} lg={4} key={turmaId}>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                p={1}
              >
                <MDTypography variant="h6" color="white" style={{ marginLeft: 8 }} p={1}>
                  {nomeTurma} ({alunos.length} aluno{alunos.length !== 1 ? 's' : ''})
                </MDTypography>
              </MDBox>
              {alunos.map((item) => (
                <MDButton
                  key={`${turmaId}-${item.clienteId}`}
                  style={{ marginTop: 8, backgroundColor: '#fff', width: '100%', justifyContent: 'flex-start' }}
                >
                  <MDTypography style={{ marginLeft: 20, textAlign: 'start' }}>
                    {item.nomeCliente}
                  </MDTypography>
                </MDButton>
              ))}
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}